export const hasIntersection = function hasIntersection(array1, array2) {
  if (array1.length === 0 || array2.length === 0) {
    return false;
  }
  const [shortest, longest] = array1.length <= array2.length ? [array1, array2] : [array2, array1];
  return shortest.some(data => longest.indexOf(data) > -1);
};